import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    height: 0;\n    margin: 0;\n    opacity: 0;\n    position: absolute;\n    width: 0;\n\n    &:not(:checked) + ", ":before, &:checked + ", ":before {\n        border-style: solid;\n        border-width: 1px;\n        bottom: 0;\n        box-sizing: border-box;\n        content: '';\n        height: ", "px;\n        left: 0;\n        margin: auto;\n        position: absolute;\n        top: 0;\n        width: ", "px;\n\n        ", "\n    }\n\n    &:not(:checked) + ", ":after, &:checked + ", ":after {\n        bottom: 0;\n        content: '';\n        height: ", "px;\n        left: ", "px;\n        margin: auto;\n        position: absolute;\n        top: 0;\n        transition: all ", "s ease;\n        width: ", "px;\n\n        ", "\n    }\n\n    &:not(:checked) + ", ":after {\n        opacity: 0;\n        transform: scale(0);\n    }\n\n    &:checked + ", ":after {\n        opacity: 1;\n        transform: scale(1);\n    }\n\n    &:not(:disabled):checked + ", ":before {\n        ", "\n    }\n\n    &:not(:disabled):checked\n        + ", ":hover:before,\n        &:not(:disabled):not(:checked)\n        + ", ":hover:before {\n        ", "\n    }\n\n    &:not(:disabled):checked + ", ":hover:after {\n        ", "\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    cursor: pointer;\n    display: inline-flex;\n    padding-left: ", "px;\n    position: relative;\n\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n    ", ";\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { marginAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';
import { mouseCursor } from '../../styling';
import { transitionDurationInSec } from '../../constants';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var sizes = {
  container: {
    side: 16
  },
  dot: {
    side: 8,
    offset: 4
  }
};

var containerStyle = function containerStyle(_ref) {
  var Radio = _ref.theme.componentOverrides.Radio,
      disabled = _ref.disabled;
  return disabled ? Radio.Container.disabled : Radio.Container.base;
};

var containerStyleHighlighted = function containerStyleHighlighted(_ref2) {
  var Radio = _ref2.theme.componentOverrides.Radio;
  return Radio.Container.highlighted;
};

var containerStyleOnHover = function containerStyleOnHover(_ref3) {
  var Radio = _ref3.theme.componentOverrides.Radio;
  return Radio.Container.hover;
};

var dotStyleOnHover = function dotStyleOnHover(_ref4) {
  var Radio = _ref4.theme.componentOverrides.Radio;
  return Radio.Dot.hover;
};

var dotStyle = function dotStyle(_ref5) {
  var Radio = _ref5.theme.componentOverrides.Radio,
      disabled = _ref5.disabled;
  return disabled ? Radio.Dot.disabled : Radio.Dot.base;
};

var radioRootStyle = function radioRootStyle(_ref6) {
  var Radio = _ref6.theme.componentOverrides.Radio;
  return Radio.Root.base;
};

export var RadioRoot = styled.div.withConfig(getPropsBlocker())(_templateObject(), radioRootStyle, getComponentOverride('Radio'), marginAttributes);
export var RadioMark = styled.label.withConfig(getPropsBlocker())(_templateObject2(), sizes.container.side, mouseCursor);
export var RadioInput = styled.input.withConfig(getPropsBlocker())(_templateObject3(), RadioMark, RadioMark, sizes.container.side, sizes.container.side, containerStyle, RadioMark, RadioMark, sizes.dot.side, sizes.dot.offset, transitionDurationInSec, sizes.dot.side, dotStyle, RadioMark, RadioMark, RadioMark, containerStyleHighlighted, RadioMark, RadioMark, containerStyleOnHover, RadioMark, dotStyleOnHover);